import React, { Component } from "react";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";
import { apiService } from "../../base/utils/service";
import Spinner from "../../base/features/micro/Spinner";
import { Link } from "react-router-dom";
import ProductCard from "../../base/features/blocks/ProductCard";
import { navigate_to_shop_cart_invoice } from "../../navigator/user/cart";
import {
  navigate_to_shop,
  navigate_to_shop_from_url,
} from "../../navigator/user/shop";

class AfterPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice_uid: window.location.pathname.split("/")[3],
    };
  }
  componentDidMount() {
    this.getPaymentResult();
  }
  getPaymentResult() {
    apiService(`v1/payment/checkout/${this.state.invoice_uid}`).then((data) => {
      if (data) {
        this.setState({ paymentProperties: data });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid px-0" dir="rtl">
        <SimpleHeader text="نتیجه تراکنش" path={navigate_to_shop_from_url()} />
        <body
          className="px-0"
          style={{ marginTop: "90px", marginBottom: "110px" }}
        >
          {this.state.paymentProperties ? (
            <div className="row mx-0 px-0">
              {this.state.paymentProperties.is_pay ? (
                <div className="col-12 px-4 align-self-center">
                  <img
                    alt="payment-success"
                    src={
                      require("../../base/assets/icons/payment-success.svg")
                        .default
                    }
                  />
                  <h2 className="fs-4 fw-bolder mt-4">سفارش ثبت شد</h2>
                </div>
              ) : (
                <div className="container-fluid px-4">
                  <div className="col-12 px-0 align-self-center">
                    <img
                      alt="payment-success"
                      src={
                        require("../../base/assets/icons/payment-err.svg")
                          .default
                      }
                    />
                    <h2 className="fs-4 fw-bolder mt-4">پرداخت ناموفق</h2>
                    {this.state.paymentProperties.can_pay && (
                      <div className="row mx-0 px-0">
                        <div className="col px-0">
                          <p className="text-danger small">
                            مدت زمان باقی مانده برای پرداخت مجدد
                          </p>
                        </div>
                        <div className="col-auto px-0">
                          <p className="text-danger small fw-bold">
                            {this.state.paymentProperties.time_to_pay}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className="row px-0 mx-0 px-0 mt-3 position-fixed"
                    style={{
                      bottom: "15px",
                      right: "20px",
                      left: "20px",
                      zIndex: "99",
                    }}
                  >
                    <Link
                      className="col-12 p-0"
                      to={
                        this.state.paymentProperties.can_pay
                          ? navigate_to_shop_cart_invoice(
                              this.state.paymentProperties.shop.uid,
                              this.state.paymentProperties.cart.uid,
                              "gateway"
                            )
                          : navigate_to_shop(
                              this.state.paymentProperties.shop.uid
                            )
                      }
                    >
                      <button className="btn fw-bold bg-disabled text-white bg-color-main rounded28 py-2 w-100">
                        {this.state.paymentProperties.can_pay
                          ? "پرداخت مجدد"
                          : "رفتن به صفحه فروشگاه"}
                      </button>
                    </Link>
                  </div>
                </div>
              )}
              <div className="row mx-0 px-0">
                <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center">
                  تراکنش های سفارش
                </div>
                {this.state.paymentProperties.transactions.map(
                  (transaction, t) => (
                    <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
                      <div className="row px-0 mx-0">
                        <div className="col-auto small px-0 fw-bold align-self-center">
                          {transaction.is_pay ? (
                            <img
                              width={20}
                              alt="payment-success"
                              src={
                                require("../../base/assets/icons/payment-success.svg")
                                  .default
                              }
                            />
                          ) : (
                            <img
                              width={20}
                              alt="payment-success"
                              src={
                                require("../../base/assets/icons/payment-err.svg")
                                  .default
                              }
                            />
                          )}
                        </div>
                        <div className="col px-2 align-self-center">
                          {transaction.gateway.title}
                        </div>

                        <div className="col-auto small px-0 fw-bold align-self-center">
                          {transaction.created}
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="row mx-0 px-0">
                <div className="col-12 mt-4 px-4">
                  <p className="fw-bolder fs-6">اقلام</p>
                </div>
                {this.state.paymentProperties.items.map((product, p) => (
                  <div key={p} className="col-12 px-0 border-bottom">
                    <ProductCard
                      image={product.image}
                      name={product.name}
                      shopUid={this.state.shop_uid}
                      payable_price={product.payable_price}
                      quantity={product.quantity}
                      isOrder={true}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <Spinner />
          )}
        </body>
      </div>
    );
  }
}

export default AfterPayment;
